import { render, staticRenderFns } from "./biIntroduce.vue?vue&type=template&id=0123f51c&scoped=true&"
import script from "./biIntroduce.vue?vue&type=script&lang=js&"
export * from "./biIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./biIntroduce.vue?vue&type=style&index=0&id=0123f51c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123f51c",
  null
  
)

export default component.exports